import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  async connect() {
    const modalId = this.element.getAttribute("data-modal-target");
    const modal = document.getElementById(modalId);
    if (!modal) {
      console.error(`Modal with id ${modalId} not found`);
      return;
    }
    this.element.addEventListener("click", (e) => {
      e.preventDefault();
      modal.showModal();
    });
  }
}
